import {
  call,
  put,
  all,
  spawn,
  takeEvery,
  takeLatest,
} from 'redux-saga/effects';
import request from '../../utils/request';
import { AUDIT_HEADER, FETCH_API_KEYS_URL } from '../../utils/constants';
import {
  fetchAPIKeysSaveResponseAction,
  generateAPIKeySaveResponseAction,
  resetAPIKeySaveResponseAction,
  saveGetApiKeyByAppIdResponse,
  disableLoaderAction,
} from './actions';

import { showToast } from '../Toast/actions';

import {
  FETCH_API_KEYS,
  GENERATE_API_KEY,
  GENERATE_API_KEY_URL,
  RESET_API_KEY,
  RESET_API_KEY_URL,
  GET_API_KEY_BY_APP_ID,
  GET_API_KEY_BY_APP_URL,
} from './constants';

const DEVELOPERS_API_AUDIT = 'developer-api-keys-audit';

export function* fetchAPIKeysFn({ data }) {
  try {
    const { options, successCb } = data;
    const { url, method } = FETCH_API_KEYS_URL;

    const envCall = data?.envCall || {};

    const reqOptions = {
      ...options,
      header: {
        'Content-type': 'application/json',
      },
      method,
      ...(Object.keys(envCall).length ? { envCall } : {}),
    };
    const response = yield call(request, url, reqOptions);
    yield put(fetchAPIKeysSaveResponseAction({ data: response }));
    if (successCb) successCb(response);
  } catch (err) {
    yield put(disableLoaderAction());
    yield put(showToast(err));
  }
}

export function* generateAPIKeyFn({ data: { successCb, failureCb, envCall } }) {
  try {
    const { url, method } = GENERATE_API_KEY_URL;
    const options = {
      headers: {
        'Content-type': 'application/json',
        [AUDIT_HEADER]: DEVELOPERS_API_AUDIT,
      },
      method,
      envCall,
    };
    const response = yield call(request, url, options);
    yield put(generateAPIKeySaveResponseAction({ data: response }));
    if (successCb) successCb(response);
  } catch (err) {
    yield put(disableLoaderAction());

    if (failureCb) {
      failureCb(err);
    } else {
      yield put(showToast(err));
    }
  }
}

export function* resetAPIKeyFn({ data: { appId, successCb, errorCb } }) {
  try {
    const { url, method } = RESET_API_KEY_URL;
    const options = {
      headers: {
        'Content-type': 'application/json',
        [AUDIT_HEADER]: DEVELOPERS_API_AUDIT,
      },
      method,
    };

    const response = yield call(
      request,
      url.replace('$app_id$', appId),
      options,
    );
    yield put(resetAPIKeySaveResponseAction({ data: response }));
    if (successCb) successCb();
  } catch (err) {
    if (errorCb) errorCb();
    yield put(disableLoaderAction());
    yield put(showToast(err));
  }
}

export function* viewAPIKeyFn({ data: { appId, successCb } }) {
  try {
    const { url, method } = GET_API_KEY_BY_APP_URL;
    const options = {
      headers: {
        'Content-type': 'application/json',
        [AUDIT_HEADER]: DEVELOPERS_API_AUDIT,
      },
      method,
    };

    const response = yield call(
      request,
      url.replace('$app_id$', appId),
      options,
    );
    yield put(saveGetApiKeyByAppIdResponse({ data: response }));
    if (successCb) successCb();
  } catch (err) {
    yield put(disableLoaderAction());
    yield put(showToast(err));
  }
}

export function* fetchAPIKeysSaga() {
  yield takeEvery(FETCH_API_KEYS, fetchAPIKeysFn);
}

export function* generateAPIKeySaga() {
  yield takeEvery(GENERATE_API_KEY, generateAPIKeyFn);
}

export function* resetAPIKeySaga() {
  yield takeEvery(RESET_API_KEY, resetAPIKeyFn);
}

export function* viewAPIKeySaga() {
  yield takeLatest(GET_API_KEY_BY_APP_ID, viewAPIKeyFn);
}

// Individual exports for testing
export default function* apiKeysSaga() {
  // See example in containers/HomePage/saga.js

  const sagas = [
    fetchAPIKeysSaga,
    generateAPIKeySaga,
    resetAPIKeySaga,
    viewAPIKeySaga,
  ];

  yield all(
    sagas.map(saga =>
      // eslint-disable-next-line func-names
      spawn(function*() {
        while (true) {
          try {
            yield call(saga);
            break;
          } catch (e) {
            // eslint-disable-next-line no-console
            console.log(e);
          }
        }
      }),
    ),
  );
}
